module.exports = __webpack_public_path__ + "static/assets/b3aeec4fa405decd74d855742b2d592a.svg";